exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page_home_other .v-chip__content{font-size:1.5rem}", ""]);

